import { render, staticRenderFns } from "./RegisterSuccess.vue?vue&type=template&id=1fe349d3&scoped=true&"
import script from "./RegisterSuccess.vue?vue&type=script&lang=js&"
export * from "./RegisterSuccess.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/frontend/home.scss?vue&type=style&index=0&id=1fe349d3&lang=scss&scoped=true&"
import style1 from "@/assets/scss/frontend/content.scss?vue&type=style&index=1&id=1fe349d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe349d3",
  null
  
)

export default component.exports